import React from 'react';

/*eslint-disable */

var facebookIcon = (function (_ref) {
  var alt = _ref.alt;
  return /*#__PURE__*/React.createElement("svg", {
    width: "9px",
    height: "16px",
    viewBox: "0 0 9 16",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/React.createElement("title", null, alt), /*#__PURE__*/React.createElement("path", {
    d: "M5.38496385,16 L5.38496385,8.70169121 L7.83102741,8.70169121 L8.19723541,5.85735974 L5.38496385,5.85735974 L5.38496385,4.0413798 C5.38496385,3.21787946 5.61326217,2.65671009 6.79240399,2.65671009 L8.2962963,2.65600395 L8.2962963,0.1120644 C8.03612927,0.0774635455 7.14345321,0 6.10490029,0 C3.93663024,0 2.45226809,1.32549518 2.45226809,3.75977121 L2.45226809,5.85735974 L0,5.85735974 L0,8.70169121 L2.45226809,8.70169121 L2.45226809,16 L5.38496385,16 Z"
  }));
});

export { facebookIcon as default };
